import lodashPick from 'lodash/fp/pick';

export const assemblyLineApplicationStatusOverrideFieldgroup = [
  'statusOverrideMoveInDate',
  'statusOverrideLeaseTerm',
  'statusOverrideSsn',
  'statusOverrideCreditScore',
  'statusOverrideDependents',
  'statusOverrideBackgroundCheck',
  'statusOverrideIncomeVerification',
  'statusOverridePetInfo',
];

export const assemblyLineApplicationOfferLetterFieldgroup = [
  'offerLetterCompanyLetterHeadExistsOk',
  'offerLetterCompanyLetterHeadNameOk',
  'offerLetterEmployersName',
  'offerLetterCompensationType',
  'offerLetterSalaryAmount',
  'offerLetterSpecifiesHoursPerWeek',
  'offerLetterHoursPerWeek',
  'offerLetterHourlyWage',
  'offerLetterIssuedDate',
  'offerLetterStartDate',
  'offerLetterVerified',
  'offerLetterShouldCountIncomeSource',
  'offerLetterShouldIncludePartnerDocs',
  'offerLetterMissingInformationFieldIds',
];

export const assemblyLineApplicationEditableFieldgroup = [
  'governmentIdNameOk',
  'backgroundCheckWarningOk',
  'backgroundCheckCriminalSearchOk',
  'backgroundCheckEvictionSearchOk',
  'backgroundCheckSexOffenderSearchOk',
  'backgroundCheckFederalSearchOk',
  'paystubs',
  'bankStatements',
  'pets',
  'paystubsShouldCountIncomeSource',
  'paystubsShouldIncludePartnerDocs',
  'bankStatementsShouldCountIncomeSource',
  'bankStatementsShouldIncludePartnerDocs',
  'additionalProofOfIncomePhotos',
  ...assemblyLineApplicationOfferLetterFieldgroup,
  ...assemblyLineApplicationStatusOverrideFieldgroup,
];

export const pickAssemblyLineApplicationEditableFields = lodashPick(
  assemblyLineApplicationEditableFieldgroup,
);

export const pickAssemblyLineApplicationOfferLetterFields = lodashPick(
  assemblyLineApplicationOfferLetterFieldgroup,
);
